import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class CommonService {
  constructor(
    protected root_path: string,
    protected requestService: RequestService,
  ) { }

  public getAll(
    query?: any,
    is_loading: boolean = true,
    is_snack_bar: boolean = false
  ): Observable<any> {
    if (!this.root_path) throw new Error('Root path is empty');
    return this.requestService.postJSON(this.root_path, {
      data: query,
      option: {
        is_loading: is_loading,
        is_snack_bar: is_snack_bar,
      },
    });
  }

  public getByID(
    id: string,
    is_loading: boolean = true,
    is_snack_bar: boolean = false
  ): Observable<any> {
    if (!this.root_path) throw new Error('Root path is empty');
    return this.requestService.getJSON<any>(`${this.root_path}/${id}`, {
      option: { is_loading: is_loading, is_snack_bar: is_snack_bar },
    });
  }

  public save(
    payload: any,
    is_loading: boolean = true,
    is_snack_bar: boolean = false
  ): Observable<any> {
    if (!this.root_path) throw new Error('Root path is empty');
    return this.requestService.postJSON(`${this.root_path}/save`, {
      data: payload,
      option: {
        is_loading: is_loading,
        is_snack_bar: is_snack_bar,
      },
    });
  }

  delete(id: string, is_loading: boolean = true): Observable<any> {
    return this.requestService.deleteJSON(this.root_path + `/${id}/delete`, {
      data: {},
      option: {
        is_loading: is_loading,
      },
    });
  }

}
